import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import Frame from '../components/Frame.tsx';
import ScatterPlot from '../components/ScatterPlot';
import cars from '../data/cars';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "scatter-plot"
    }}>{`Scatter Plot`}</h1>
    <p>{`See the component `}<a parentName="p" {...{
        "href": "https://github.com/kristw/encodable/tree/master/packages/docs/src/components/ScatterPlot"
      }}>{`source code`}</a>{`.
or play with the component API by editing the code below.`}</p>

    <Playground __position={0} __code={'<Frame width={360} height={270} background=\"#FED92A\">\n  <ScatterPlot\n    width={360}\n    height={270}\n    data={cars}\n    encoding={{\n      x: {\n        type: \'quantitative\',\n        field: \'x\',\n        scale: { type: \'linear\', nice: true },\n        axis: { title: \'Miles per gallon →\' },\n      },\n      y: {\n        type: \'quantitative\',\n        field: \'y\',\n        axis: { title: \'↑ Horsepower\' },\n      },\n      stroke: { value: \'#333\' },\n      fill: { value: \'none\' },\n    }}\n  />\n</Frame>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Frame,
      ScatterPlot,
      cars,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Frame width={360} height={270} background="#FED92A" mdxType="Frame">
    <ScatterPlot width={360} height={270} data={cars} encoding={{
          x: {
            type: 'quantitative',
            field: 'x',
            scale: {
              type: 'linear',
              nice: true
            },
            axis: {
              title: 'Miles per gallon →'
            }
          },
          y: {
            type: 'quantitative',
            field: 'y',
            axis: {
              title: '↑ Horsepower'
            }
          },
          stroke: {
            value: '#333'
          },
          fill: {
            value: 'none'
          }
        }} mdxType="ScatterPlot" />
  </Frame>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      